import { render } from "./ProcessoComponent.vue?vue&type=template&id=3d2a4264&scoped=true"
import script from "./ProcessoComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoComponent.vue?vue&type=script&lang=js"

import "./ProcessoComponent.vue?vue&type=style&index=0&id=3d2a4264&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2a4264"]])

export default __exports__